import moment from "moment-timezone";

/**
 * IANA timezone for physician review APIs.
 * Uses app Configuration when set; falls back to browser guess for local dev.
 */
export const getClientTimezone = (
  configuredTimezone?: string | null,
): string => {
  const configured = configuredTimezone?.trim();
  if (configured && moment.tz.zone(configured)) {
    return configured;
  }
  return moment.tz.guess();
};
